export default {
    forkliftCode: [{ required: true, message: '请输入叉车编号', trigger: ['blur'] }],
    deliveryDate: [{ required: true, message: '请选择出厂时间', trigger: ['blur'] }],
    enableFlag: [{ required: true, message: '请选择叉车状态', trigger: ['change'] }],
    deviceType: [{ required: true, message: '请选择设备类型', trigger: ['change'] }],
    deviceBrand: [{ required: true, message: '请选择设备品牌', trigger: ['change'] }],
    model: [{ required: true, message: '请输入型号', trigger: ['blur'] }],
    payload: [{ required: true, message: '请输入核载重量', trigger: ['blur'] }]
};